import { initialTheme } from '@/utils/helpers'

const state = {
  theme: {
    ...initialTheme()
  },
  customCss: null
}

const mutations = {
  setTheme(state, payload) {
    state.theme = payload
  },
  setCustomCss(state, css) {
    state.customCss = css
  },
  updateSpecificCssPreset(state, cssInfo) {
    const { preset, css } = cssInfo
    state.customCss[preset] = css
  }
}

const actions = {
  updateTheme({ commit, state }, newTheme) {
    const theme = {
      ...state.theme,
      ...newTheme
    }
    commit('setTheme', theme)
    commit('reloadCashierMutation')
  },
  overwriteTheme({ commit }, newTheme) {
    const theme = {
      ...newTheme
    }
    commit('setTheme', theme)
    commit('reloadCashierMutation')
  }
}

export default {
  state,
  mutations,
  actions
}
